module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_8004.df0b70a0.png";